




























import { Component, Vue } from "vue-property-decorator";
import NewsApi from "@/services/News";
import AuthModule from "@/store/auth";
import { News } from "@/api/lab-base-api-client";
import dayjs from "dayjs";

@Component
export default class NewsList extends Vue {
  // お知らせ一覧
  private newsList: News[] = [];

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // アカウント情報の取得
  private async mounted() {
    await this.fetchNews();
  }

  // お知らせの取得
  private async fetchNews() {
    const newsRes = await NewsApi.instance.getNews();
    if (newsRes.data.data) {
      this.newsList = newsRes.data.data.items;
    }

    // 各ニュースの作成日をyyyy/mm/dd形式に変更
    this.newsList.forEach((news: News, index: number) => {
      this.newsList[index].createdAt = String(dayjs(news.createdAt).format("YYYY/MM/DD"));
    });
  }
}
